"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    title: {
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing()
    },
    titleColor: {
        color: theme.palette.common.black
    },
    center: {
        alignSelf: 'center'
    },
    lastButton: {
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(2)
    },
    close: {
        display: 'flex',
        justifyContent: 'flex-end',
        minHeight: '3rem',
        paddingTop: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5)
    },
    ieMinHeight: {
        minHeight: '35em'
    },
    noPadding: {
        [theme.breakpoints.down('xs')]: {
            padding: 0
        }
    },
    smallDevice: {
        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing()
        }
    },
    noMargin: {
        [theme.breakpoints.down('xs')]: {
            margin: 0
        }
    },
    gameViewContent: {
        height: '98%',
        maxHeight: '98%',
        maxWidth: 1050,
        [theme.breakpoints.down('md')]: {
            height: '100%',
            width: '100%',
            margin: 0,
            maxHeight: '100%'
        }
    },
    gameView: {
        overflow: 'hidden',
        height: '100%',
        [theme.breakpoints.down('md')]: {
            padding: 0,
            margin: 0
        }
    },
    portraitMode: {
        maxWidth: 540
    },
    noHorizontalScroll: {
        overflowX: 'hidden'
    },
    reducedWidth: {
        width: '30%'
    },
    noVerticalScroll: {
        overflowY: 'hidden'
    },
    closeButton: {
        '&:focus': {
            backgroundColor: theme.palette.action.focus
        }
    }
});
exports.default = styles;
//# sourceMappingURL=InformationDialogStyle.js.map